
const company = (state = {}, action) => {
  switch (action.type) {
    case 'GET_COMPANY':
      return {
        ...state,
        details: action.payload.company
      };
    default:
      return state;
  }
};

export default company


// WEBPACK FOOTER //
// ./src/reducers/company.js